var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paymentPreferences && !_vm.paymentPreferences.payment_method_id)?_c('div',{staticClass:"payment-method-alert"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('div',{staticClass:"block d-md-flex align-items-center"},[_c('p',{staticClass:"mb-0"},[_vm._v(" Reminder: Please complete your royalty payment preferences. ")]),_c('ebp-button',{staticClass:"ml-md-2 mt-md-0 mt-3",attrs:{"size":"sm","to":{
          name: 'MyProfile',
          query: { tab: 'payment-preferences' }
        }}},[_vm._v(_vm._s(_vm.$t("add-method")))])],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }